import utils from '@/utils/utils'
//

const Pagination = {
  // Parent props
  props: ['pageIndex', 'listSettings'],
  // Data
  data() {
    return {
      activePage: this.pageIndex,
      atBeginning: false,
      atEnd: false,
      breakpoint: 736,
      inBreakpoint: false,
      showNav: true,
      surroundingActive: 2,
    }
  },
  // Methods
  methods: {
    handleClick: function (value) {
      switch (value) {
        case 'prev':
          this.activePage--
          break
        case 'next':
          this.activePage++
          break
        default:
          this.activePage = value
      }
      // Set state
      const payload = {
        type: 'pageIndex',
        value: this.activePage < 1 || !this.activePage ? 1 : this.activePage,
      }
      this.$store.dispatch('filters/setFilter', payload)
      //
      this.checkPosition()
      bus.$emit('product_list_scroll')
      this.updateQueryString()
    },
    updateQueryString: function () {
      bus.$emit('query_string_update')

      const key = 'pageIndex'
      const searchString = utils.getSearchString()
      const queryStringParams = new URLSearchParams(searchString)

      if (!this.activePage) {
        queryStringParams.delete(key)
      } else {
        queryStringParams.set(key, this.activePage)
      }

      const newURL =
        window.location.origin +
        window.location.pathname +
        '?' +
        queryStringParams.toString()
      window.history.pushState({path: newURL}, '', newURL)
    },
    handleResize(windowSize) {
      if (windowSize.width < this.breakpoint) {
        this.inBreakpoint = true
      } else {
        this.inBreakpoint = false
      }
    },
    checkPosition: function () {
      const pageRange = this.surroundingActive * 2 + 1

      const atBeginning = this.activePage <= pageRange
      const atEnd = this.listSettings.pageCount - this.activePage < pageRange

      this.atBeginning = atBeginning ? atBeginning : false
      this.atEnd = atEnd ? atEnd : false
    },
    startDots: function () {
      const pageRange = this.surroundingActive * 2 + 1

      return (
        this.listSettings.pageCount > pageRange + 1 &&
        (!this.atBeginning || (this.inBreakpoint && this.activePage > 1))
      )
    },
    endDots: function () {
      const pageRange = this.surroundingActive * 2 + 1

      return (
        this.listSettings.pageCount > pageRange + 1 &&
        (!this.atEnd ||
          (this.inBreakpoint && this.activePage < this.listSettings.pageCount))
      )
    },
    middleItems: function (item) {
      const pageRange = this.surroundingActive * 2 + 1
      const itemIsActive = item === this.activePage
      const itemWithinLowerRange =
        Math.abs(this.activePage - item) <= this.surroundingActive
      const itemWithinUpperRange =
        Math.abs(item - this.activePage) <= this.surroundingActive

      return (
        item != 1 &&
        item != this.listSettings.pageCount &&
        this.listSettings.pageCount >= 3 &&
        (itemIsActive ||
          (itemWithinLowerRange && !this.atEnd) ||
          (itemWithinUpperRange && !this.atBeginning) ||
          (this.atBeginning && item <= pageRange) ||
          (this.atEnd && item > this.listSettings.pageCount - pageRange))
      )
    },
    resetPagination: function () {
      this.activePage = 1
      this.updateQueryString()
    },
  },
  // Life cycle
  created() {
    bus.$on('reset_pagination', () => {
      this.resetPagination()
    })
    bus.$on('window_resize', windowSize => {
      this.handleResize(windowSize)
    })
  },
  mounted() {
    this.checkPosition()
  },
}

export default Pagination
